<template>
  <b-form @submit.prevent="submit" class="component">
    <b-form-row
      class="thread-select-query-form"
      :style="{
        top: getOffsetValue + 50 + 'px'
      }"
    >
      <b-form-group class="group" :class="{ 'is-cra-create-query': !replyQuery }" :invalid-feedback="errors.first('comment')" :state="veeFields.comment && (veeFields.comment.dirty || submited) ? !errors.has('comment') : null">
        <b-form-textarea class="cra-query-form-comment" id="comment" name="comment" placeholder="Enter your comment" :rows="6" :state="veeFields.comment && (veeFields.comment.dirty || submited) ? !errors.has('comment') : null" v-model="comment" v-validate="'required'"></b-form-textarea>
      </b-form-group>

      <b-form-row v-if="!replyQuery">
        <b-col class="select-assignee-container">
          <div class="assigne-query-label">
            Assign query
          </div>
          <select class="form-control select-group select-drop-down select_section" v-model="assigneeId">
            <option value="null" selected disabled>Select a user to assign</option>
            <option v-for="(assignee, index) in getSortedUserList" :key="index" :value="assignee.id">{{ getUserName(assignee) }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col class="thread-query-form-submit">
          <button-cmp variant="outline-primary" @click="cancel" class="ml-2 cancelBtn cancelBtnLabel">Cancel</button-cmp>
          <button-cmp type="submit" variant="primary">{{ saveBtnText }}</button-cmp>
        </b-col>
      </b-form-row>
    </b-form-row>
  </b-form>
</template>

<script>
import ButtonCmp from "@/components/common/button";
import { capitalize, sortBy } from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "form-queries-comment-form",
  components: {
    ButtonCmp
  },
  props: {
    saveBtnText: {
      type: String,
      default: "Create Query"
    },
    siteTeamList: {
      type: Array
    },
    replyQuery: {
      type: Boolean
    },
    getOffsetValue: Number
  },
  data() {
    return {
      comment: "",
      limit: 500,
      submited: false,
      assigneeId: null,
      siteUsers: [],
      allUsers: []
    };
  },
  watch: {
    comment(val) {
      if (val && val.length > this.limit) {
        this.comment = val.slice(0, this.limit);
      }
    }
  },
  computed: {
    ...mapGetters(["user"]),
    getSortedUserList() {
      return sortBy(this.siteTeamList, [
        function(o) {
          return o.firstName.toLowerCase().trim() + o.lastName.toLowerCase().trim();
        }
      ]);
    }
  },
  mounted() {
    this.getAllUsers();
    this.$root.$on("openQueriesFormOpen", data => {
      this.getOffsetValue = data - 100;
    });
  },
  methods: {
    getAllUsers() {
      const associated = true;
      const studyId = this.$route.params.studyId;
      this.$api.getStudyTeamFact(studyId).then(
        response => {
          if (associated) {
            this.siteUsers = response.body;
          } else {
            this.members = response.body;
            this.allUsers = response.body;
            this.allUsers.forEach(element => {
              const user = element;
              user.selected = false;
            });
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study team details.");
        }
      );
    },
    getUserName(assignee) {
      return assignee && capitalize(assignee.firstName) + " " + capitalize(assignee.lastName);
    },
    submit() {
      this.submited = true;
      return this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$emit("submit", this.comment, this.assigneeId);
        } else {
          throw new Error("Invalid comment data");
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .thread-select-query-form {
    flex-direction: column;
    top: 0px;
    position: relative;
    width: 100%;
    padding-top: 18px;
    padding-bottom: 10px;
  }
  .cra-query-form-comment {
    border-top: solid 2px #ced4da;
    border-left: none;
    border-right: none;
    border-bottom: 2px solid #ced4da;
    border-radius: 0px;
    margin-bottom: 0px;
    min-height: 150px;
  }
  .is-cra-create-query {
    border-right: solid 2px #ced4da;
    background-color: #f7f7f7;
  }
  .select-assignee-container {
    padding: 0px 1rem 6px;
    display: flex;
    flex-direction: row;
    border-bottom: solid 2px #ced4da;
    border-right: solid 2px #ced4da;
    margin-bottom: 12px;
    background-color: #f7f7f7;
    .form-control {
      &:focus {
        box-shadow: none;
      }
    }
  }
  .assigne-query-label {
    color: #666669;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding-right: 1rem;
  }
  .select-drop-down {
    width: 60%;
    background-color: #fff;
    padding: 2px 6px 2px 10px;
    border: solid 2px #d3dfe4;
  }
  .thread-query-form-submit {
    display: flex;
    justify-content: flex-end;
    padding-right: 2rem;
  }
  .cancelBtnLabel {
    color: #666669;
    font-weight: normal;
    text-transform: capitalize;
    border: none;
    font-size: 14px;
  }
}
.form-row {
  margin-left: 0px;
  margin-right: 0px;
}
.note {
  color: grey;
  font-size: 0.8rem;
}
.group {
  width: 100%;
  margin-bottom: 0px;
  padding-bottom: 6px;
}
</style>
